import { Component, inject, input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { LocationFacility } from 'src/app/features/charging-station-location/charging-station-location-model';
import { AdminEnumSelectListMultipleComponent } from '../admin-enum-select-list-multiple/admin-enum-select-list-multiple.component';
import { TranslateLocationFacilityPipe } from '../../pipes/translate-location-facility.pipe';

@Component({
  selector: 'adm-location-facilities-select',
  templateUrl: './location-facilities-select.component.html',
  imports: [AdminEnumSelectListMultipleComponent],
  providers: [TranslateLocationFacilityPipe],
})
export class LocationFacilitiesSelectComponent {
  facilityPipe = inject(TranslateLocationFacilityPipe);

  control = input.required<FormControl<LocationFacility[] | null>>();

  facilityEnumValues = Object.values(LocationFacility).sort((a, b) =>
    this.facilityPipe.transform(a).localeCompare(this.facilityPipe.transform(b))
  );

  onFacilitiesChanged(facilities: LocationFacility[] | null): void {
    this.control().patchValue(facilities ?? []);
  }
}
